import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorM2ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorM2ByHealthTeamData {
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	totalAttendances: number = 0;
	totalNonSharedAttendances: number = 0;
	totalSharedAttendances: number = 0;
}

export async function getResumeIndicatorM2ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorM2ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorM2ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m2/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorM2ByHealthTeamData>();
}
